import SanitasTerms from './src/SanitasTerms'
import { loadLabels } from './src/services/backend'

export { loadLabels }
export default SanitasTerms
